import { UseFormReturn } from 'react-hook-form'
// import { addDays, format, parse } from 'date-fns'

import { CustomFormQuestion } from 'components/tools/CustomForm/types'

type Params = {
  formMethods: UseFormReturn<any>
  questions: CustomFormQuestion[]
}

export default function setRecessoBolsista(params: Params): CustomFormQuestion[] {
  const { formMethods, questions } = params

  const { watch } = formMethods

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  const numeroDeDiasDeAtestado = watch(`form_answers.${titleForQuestion['Quantidade de dias']}`)

  const filteredQuestions = questions.filter((question) => {
    if (
      question.title == 'Data de início do recesso - segundo período' ||
      question.title == 'Término do recesso - segundo período'
    ) {
      if (numeroDeDiasDeAtestado === '15 dias') {
        return true
      } else {
        return false
      }
    } else {
      return true
    }
  })

  return filteredQuestions
}
